﻿import { WorkItemInfo } from 'runtime/data/workiteminfo';

export class CancelClaimRequested {
    constructor(public workItemInfo: WorkItemInfo, public completionAction: () => void) {}

    static eventName() { return 'WorkTray.CancelClaimRequested'; }

    eventName = CancelClaimRequested.eventName;
}